<ng-container *ngFor="let transaction of events">
  <div class="ticket" *ngIf="transaction.events[0]">
    <div class="teams">
      <img [src]="'img/logo-klubova/'+transaction.events[0].team1Logo" *ngIf="transaction.events[0].team1Logo" class="team-logo" />
      <span *ngIf="transaction.events[0].team2Logo">VS</span>
      <img [src]="'img/logo-klubova/'+transaction.events[0].team2Logo" *ngIf="transaction.events[0].team2Logo" class="team-logo" />
    </div>

    <span class="title">{{ transaction.events[0]?.name }}</span>
    <br *ngIf="transaction.docType === 'PABON'" />

    <div class="ticket-details">
      <p *ngIf="transaction.docType !== 'PABON'"><span class="bold">{{ "COMMON.GAME_DATE" | translate }}</span>: {{ transaction.events[0]?.date | date:'shortDate':'':'hr' }}</p>
      <p><span class="bold">{{ "PROFILE.ORDER_NUMBER" | translate }}:</span> {{ transaction.transId }}</p>
      <p><span class="bold">{{ "PROFILE.ORDER_DATE" | translate }}:</span> {{ transaction.transDate | date:'shortDate':'':'hr' }}</p>

      <div class="button-container" [ngClass]="{'align-left' : !transaction.events[0].getTickets }">
        <button class="btn btn-default" (click)="getTransactionInPdf(transaction.transId, 'invoice')" *ngIf="transaction.hasInvoice">{{ "PROFILE.DOWNLOAD_INVOICE" | translate }}</button>
        <button class="btn btn-secondary" (click)="getTransactionInPdf(transaction.transId, 'tickets')" *ngIf="transaction.events[0].getTickets">{{ "PROFILE.DOWNLOAD_TICKETS" | translate }}</button>
      </div> 
    </div>

    <div class="ticket-decoration">{{ "PROFILE.FINISHED" | translate }}</div>
  </div>
</ng-container>